import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Tag from './tag-model'
import { CreateTagAsync, DeleteTagAsync, LoadTagsAsync } from './tag-thunk'
const initialState: tagSliceState = {
  tag: [],
  selected_tag: '',
  is_loading_tag: false,
  is_creating_tag: false,
  is_deleting_tag: false,
}
export interface tagSliceState {
  tag: Tag[]
  selected_tag?: string
  is_loading_tag: boolean
  is_creating_tag: boolean
  is_deleting_tag: boolean
}
export const tagSlice = createSlice({
  name: 'tag',
  initialState,
  reducers: {
    setSelectedtag: (state, action) => {
      state.selected_tag = action.payload
    },
    clearStatetag: (state) => {
      state.tag = []
      state.is_loading_tag = false
      state.is_creating_tag = false
      state.is_deleting_tag = false
    },
    mergetag: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_tag = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.tag = merge(state.tag, payload) as any
        }
      }
    },

    add_tag: (state, action) => {
      if (action.payload) {
        state.tag = [...state.tag, action.payload]
      }
    },
    set_tag: (state, action) => {
      let { key, value, id } = action.payload
      state.tag = state.tag.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadTagsAsync.pending, (state) => {
      state.is_loading_tag = true
    })
    builder.addCase(LoadTagsAsync.fulfilled, (state, action) => {
      state.is_loading_tag = false
      if (action.payload) {
        state.tag = action.payload
      }
    })
    builder.addCase(LoadTagsAsync.rejected, (state) => {
      state.is_loading_tag = false
    })
    builder.addCase(CreateTagAsync.pending, (state) => {
      state.is_creating_tag = true
    })
    builder.addCase(CreateTagAsync.fulfilled, (state) => {
      state.is_creating_tag = false
    })
    builder.addCase(CreateTagAsync.rejected, (state) => {
      state.is_creating_tag = false
    })
    builder.addCase(DeleteTagAsync.pending, (state) => {
      state.is_deleting_tag = true
    })
    builder.addCase(DeleteTagAsync.fulfilled, (state, action) => {
      state.is_deleting_tag = false
      if (state.tag) {
        state.tag = state.tag.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteTagAsync.rejected, (state) => {
      state.is_deleting_tag = false
    })
  },
})

export const { clearStatetag, setSelectedtag, set_tag, mergetag, add_tag } =
  tagSlice.actions

export const get_tag =
  (id?: string) =>
  (state: {
    tag: {
      tag: Tag[]
    }
  }): Tag | null => {
    let temp = state?.tag?.tag?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.tag?.tag[0] || null
  }
export const get_selected_tag = (state: { tag: tagSliceState }): Tag | null => {
  let id = state?.tag?.selected_tag
  let temp = state?.tag?.tag?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_tag = (state: {
  tag: {
    tag: Tag[]
  }
}): Tag[] => {
  let temp = state?.tag?.tag
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_tag_busy = (state: { tag: tagSliceState }) => {
  return (
    state?.tag.is_deleting_tag ||
    state?.tag.is_loading_tag ||
    state?.tag.is_creating_tag
  )
}
export const is_deleting_tag_busy = (state: { tag: tagSliceState }) => {
  return state?.tag.is_deleting_tag
}
export const is_loading_tag_busy = (state: { tag: tagSliceState }) => {
  return state?.tag.is_loading_tag
}
export const is_creating_tag_busy = (state: { tag: tagSliceState }) => {
  return state?.tag.is_creating_tag
}

export default tagSlice.reducer
